import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/reservations'
const API_URL_EMPLOYEE =
  process.env.VUE_APP_BASE_API_URL + '/api/v1/employee/reservations'

class ReservationApi {
  getForCalendar(
    start,
    end,
    service,
    branch,
    employee,
    branchPlace,
    resource,
    customer
  ) {
    const filters = {}
    if (service !== null) {
      filters.service = service
    }
    if (branch !== null) {
      filters.branch = branch
    }
    if (employee !== null) {
      filters.employee = employee
    }
    if (branchPlace !== null) {
      filters.branchPlace = branchPlace
    }
    if (resource !== null) {
      filters.resource = resource
    }
    if (customer !== null) {
      filters.customer = customer
    }
    let filterString = ''
    Object.keys(filters).forEach(
      e => (filterString += '&filter[' + e + ']=' + filters[e])
    )
    return axios.get(
      API_URL + '?startDate=' + start + '&endDate=' + end + filterString,
      {
        headers: authHeader()
      }
    )
  }

  getCsvExport(
    start,
    end,
    service,
    branch,
    employee,
    branchPlace,
    resource,
    customer
  ) {
    const filters = {}
    if (service !== null) {
      filters.service = service
    }
    if (branch !== null) {
      filters.branch = branch
    }
    if (employee !== null) {
      filters.employee = employee
    }
    if (branchPlace !== null) {
      filters.branchPlace = branchPlace
    }
    if (resource !== null) {
      filters.resource = resource
    }
    if (customer !== null) {
      filters.customer = customer
    }
    let filterString = ''
    Object.keys(filters).forEach(
      e => (filterString += '&filter[' + e + ']=' + filters[e])
    )
    return axios.get(
      API_URL +
      '/_export/csv' +
      '?perPage=10000&startDate=' +
      start +
      '&endDate=' +
      end +
      filterString,
      {
        headers: authHeader(),
        responseType: 'blob'
      }
    )
  }

  getForEmployeeCalendar(start, end, customer) {
    const filters = {}

    if (customer !== null) {
      filters.customer = customer
    }
    let filterString = ''
    Object.keys(filters).forEach(
      e => (filterString += '&filter[' + e + ']=' + filters[e])
    )
    return axios.get(
      API_URL_EMPLOYEE +
      '?perPage=10000&startDate=' +
      start +
      '&endDate=' +
      end +
      filterString,
      {
        headers: authHeader()
      }
    )
  }

  getForEmployeeCsvExport(start, end, customer) {
    const filters = {}

    if (customer !== null) {
      filters.customer = customer
    }
    let filterString = ''
    Object.keys(filters).forEach(
      e => (filterString += '&filter[' + e + ']=' + filters[e])
    )
    return axios.get(
      API_URL_EMPLOYEE +
      '/_export/csv' +
      '?perPage=10000&startDate=' +
      start +
      '&endDate=' +
      end +
      filterString,
      {
        headers: authHeader()
      }
    )
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  getEmployeeDetail(uuid) {
    return axios.get(API_URL_EMPLOYEE + '/' + uuid, { headers: authHeader() })
  }

  delete(uuid) {
    return axios.delete(API_URL + '/' + uuid, { headers: authHeader() })
  }

  employeeDelete(uuid) {
    return axios.delete(API_URL_EMPLOYEE + '/' + uuid, {
      headers: authHeader()
    })
  }

  updateReservationState(uuid, state) {
    return axios.post(API_URL + '/' + uuid + '/_state', { reservationState: state }, { headers: authHeader() })
  }

  employeeUpdateReservationState(uuid, state) {
    return axios.post(API_URL_EMPLOYEE + '/' + uuid + '/_state', { reservationState: state }, { headers: authHeader() })
  }

  create(data) {
    return axios.post(API_URL, data, { headers: authHeader() })
  }
}

export default new ReservationApi()
